import { Autocomplete, Card, CardContent, Grid, TextField } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { IComboBoxOption, IContract, IContractProps } from "../../interfaces";
import { Values } from "../../utils";
import { ContractReferenceInput } from "../Shared/FormControls/ContractReferenceInput";
import { DatePicker } from "../Shared/FormControls/DatePicker";
import { FormSectionHeader } from "../Shared/FormSectionHeader";

export const ContractDetailForm: React.FC<IContractProps> = ({
    contract,
    updateContract,
    readonly,
    saving,
    ...props
}) => {

    useEffect(() => {
        Values.setValues("category-managers", setCategoryManagers);
        Values.setValues("contract-managers", setContractManagers);
    }, [])

    useEffect(() => {

        if (contractModel !== contract)
            setContractModel(contract);

    }, [contract])


    const [contractModel, setContractModel] = useState<IContract>(contract);

    const [contractManagers, setContractManagers] = useState<IComboBoxOption[]>([]);
    const [categoryManagers, setCategoryManagers] = useState<IComboBoxOption[]>([]);


    const handleChange = (property: string, value: string | IComboBoxOption | null, saveOnChange: boolean = true) => {
        let newModel = cloneDeep(contractModel) as any;

        newModel[property] = value;

        if (!(value as IComboBoxOption)?.id)
            if (property === "lastAudit" && value) {
                let d = new Date(value as string);
                d.setFullYear(d.getFullYear() + 1);
                newModel["nextAudit"] = d;
            }
        setContractModel(newModel as IContract);

        //to prevent excessive api calls, saving is optional
        if (saveOnChange)
            updateContract(newModel as IContract);
    }


    const handleBlur = () => {
        //reduce api calls by only updating on blur
        let newModel: IContract = cloneDeep(contractModel);
        updateContract(newModel);

    }

    return (
        <Card>

            <FormSectionHeader label="Contract / Lease Details" saving={saving} />

            <CardContent>
                <Grid container spacing={2}>

                    <Grid item xs={12}>
                        <ContractReferenceInput
                            id="contract-reference-input"
                            value={contractModel.reference}
                            onChange={(e: any) => handleChange("reference", e.currentTarget.value, false)}
                            onBlur={handleBlur}
                            disabled={readonly}
                        />
                    </Grid>
                    <Grid item xs={3} >
                        <DatePicker
                            variant="outlined"
                            label="Contract Start Date"
                            value={contractModel?.startDate}
                            onChange={(date) => handleChange("startDate", date)}
                            required={true}
                            nullable={true}
                            disabled={readonly}

                        />
                    </Grid>
                    <Grid item xs={3} >
                        <DatePicker
                            variant="outlined"
                            label="Contract End Date"
                            value={contractModel?.endDate}
                            onChange={(date) => handleChange("endDate", date)}
                            required={true}
                            nullable={true}
                            disabled={readonly}

                        />
                    </Grid>
                    <Grid item xs={3} >
                        <DatePicker
                            variant="outlined"
                            label="Last Audit Date"
                            value={contractModel?.lastAudit}
                            onChange={(date) => handleChange("lastAudit", date)}
                            required={false}
                            nullable={true}
                            disabled={readonly}

                        />
                    </Grid>
                    <Grid item xs={3} >
                        <DatePicker
                            variant="outlined"
                            label="Next Audit Date"
                            value={contractModel?.nextAudit}
                            onChange={(date) => handleChange("nextAudit", date)}
                            required={true}
                            nullable={true}
                            disabled={readonly}

                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            id="contract-manager"
                            options={contractManagers.map(x => x.value)}
                            value={contractModel.contractManager?.value || null}
                            disabled={readonly}
                            onChange={(_, value) => handleChange("contractManager", { value, id: contractManagers.filter(x => x.value === value)[0]?.id })}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Procurement Manager"
                                required

                            />}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete
                            id="category-manager"
                            options={categoryManagers.map(x => x.value)}
                            value={contractModel.categoryManager?.value || null}
                            disabled={readonly}
                            onChange={(_, value) => handleChange("categoryManager", { value, id: categoryManagers.filter(x => x.value === value)[0]?.id })}
                            renderInput={(params) => <TextField
                                {...params}
                                label="Commercial Manager"
                                required

                            />}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}